import { FieldErrorTypes, IFieldError } from 'types';
import {
  invalidLessonTimeRows,
  isLessonTimeError,
  lessonTimeRangeFromMessage,
} from 'core/utils/lessonTime';

import i18n from '../../../i18n';

/** День занятий в переменных мутации (createGroup / updateGroup / updateJournal). */
export interface ILessonTimeDay {
  startTime?: string | null;
  endTime?: string | null;
}

type TErrorLike = {
  code?: string | null;
  field?: string | null;
  message?: string | null;
} | null;

/** Ошибки формы: «конец» подсвечен у дней, которые не проходят правило. */
export interface ILessonTimeFormErrors {
  lessonsDays: Array<{ endTime: IFieldError }>;
}

/**
 * Перепроверка F8: отказ сервера `invalid_lesson_time` (поле `end_time`) —
 * под «концом» занятия, на языке экрана. Сервер пишет по-русски и с
 * введённым временем; время берём из его текста, слова — из локали.
 * `null` — среди ошибок такого отказа нет.
 */
export const lessonTimeFormErrors = (
  errors: ReadonlyArray<TErrorLike> | null | undefined,
  days: ReadonlyArray<ILessonTimeDay>,
): ILessonTimeFormErrors | null => {
  const refusal = (errors || []).find((error) => isLessonTimeError(error));
  if (!refusal) return null;
  const range = lessonTimeRangeFromMessage(refusal.message);
  const message = range
    ? i18n.t('groupPopup.validation.lessonTime.invalidRange', { range })
    : i18n.t('groupPopup.validation.lessonTime.invalid');
  const lessonsDays: Array<{ endTime: IFieldError }> = [];
  invalidLessonTimeRows(days).forEach((index) => {
    lessonsDays[index] = {
      endTime: { type: FieldErrorTypes.SERVER_ERROR, message },
    };
  });
  return { lessonsDays };
};
